module.exports = __webpack_public_path__ + "img/jambyl6.ca4918d9.jpg";